var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.42 31.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d,.e{fill:none;}.f{fill:#ffaa50;}.e{stroke:#841a0c;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.32px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M15.71,29.71c7.73,0,14-6.27,14-14S23.44,1.71,15.71,1.71,1.71,7.98,1.71,15.71s6.27,14,14,14"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 16.16,
    y1: 14.52,
    x2: 8.68,
    y2: 14.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 16.16,
    y1: 16.66,
    x2: 8.68,
    y2: 16.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 16.16,
    y1: 18.8,
    x2: 8.68,
    y2: 18.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 16.16,
    y1: 20.94,
    x2: 11.88,
    y2: 20.94
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 24.72,
    y1: 23.08,
    x2: 21.82,
    y2: 23.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M28.15,8.64h1.38v-1.07c0-.89-.72-1.6-1.6-1.6s-1.6,.72-1.6,1.6v13.91c0,.89-.72,1.6-1.6,1.6s-1.6-.72-1.6-1.6V11.31c0-.89-.72-1.6-1.6-1.6s-1.6,.72-1.6,1.6v15.51H4.93V11.31c0-.89,.72-1.6,1.6-1.6h14.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M27.93,5.96H12.95c-.89,0-1.6,.72-1.6,1.6v1.07"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 31.42,
    height: 31.42
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryLog);
export default __webpack_public_path__ + "static/media/history_log.f98bf2a59a8df5adcc8334a537116788.svg";
export { ForwardRef as ReactComponent };